import { default as React, FC, memo } from 'react'
import cn from 'classnames'
import { IDetailsOrder } from '../../../types/orders'
import { startCase } from 'lodash'
import Tooltip from '../../../components/Tooltip'

interface IOwnProps {
  order: IDetailsOrder
}

const TdProcessingStatus: FC<IOwnProps> = ({ order }) => {
  const label = startCase(order.processingStatus)

  return (
    <div className="table_td -g20">
      <div
        className={cn('table_text status -lines-2', {
          '-success': order.processingStatus === 'finished',
          '-danger':
            order.processingStatus === 'failed' ||
            order.processingStatus === 'blocked',
        })}
      >
        {order.blockedReason ? (
          <Tooltip id={`tooltip-blocked-${order.id}`}>
            <div
              className="input_list-tooltip"
              data-tip={order.blockedReason}
              data-for={`tooltip-blocked-${order.id}`}
              data-effect="solid"
              data-place="bottom"
            >
              {label}
            </div>
          </Tooltip>
        ) : (
          label
        )}
      </div>
    </div>
  )
}

export default memo(TdProcessingStatus)
